import { Navigate, Outlet } from 'react-router'
import { getToken } from '@/lib/api'

export default function GuestRoute() {
  if (getToken()) {
    return <Navigate to="/dashboard" replace />
  }
  return <Outlet />
}
